<template>
  <div class="near-match--row">
    <div class="is-flex" style="justify-content: space-between">
      <div>
        <div class="has-text-left has-text-weight-bold">
          <div v-if="this.nameEnabled">
            {{ nearMatchDisplayName }}
          </div>
        </div>
        <div
          v-if="this.fieldEnabled('SCHOOL_CODE')"
          class="has-text-grey has-text-left"
        >
          {{ nearMatch.pidSubmissionSchoolName }}
        </div>
        <div
          v-if="this.fieldEnabled('LOCAL_STUDENT_ID')"
          class="has-text-grey has-text-left"
        >
          {{ getFieldLabel(`PER:${nearMatch.pidSubmission.personType}:ASSIGN:LOCAL_STUDENT_ID`) }}:
          {{ nearMatch.pidSubmission.localStudentId }}
        </div>
      </div>
      <div class="is-flex flex-align--center">
        <router-link
          :to="{
            path: `/personid/compare/${nearMatch.pidSubmissionId}`,
          }"
        >
          <font-awesome-icon :icon="['far', 'angle-double-right']"
            size="2x"
            title="View Details"
          />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDoubleRight,
} from '@fortawesome/pro-regular-svg-icons';
import FieldLabels from '@/mixins/FieldLabels';
import { mapGetters, mapActions } from 'vuex';

library.add(
  faAngleDoubleRight,
);

export default {
  mixins: [
    FieldLabels,
  ],
  props: {
    nearMatch: {
      type: Object,
      required: true,
    },
  },
  async created() {
    await this.loadPersonTypes();
  },
  computed: {
    ...mapGetters('propertiesModule', [
      'properties',
    ]),
    ...mapGetters('fieldLabelsModule', [
      'getFieldLabel',
      'getFieldEnabledForPersonType',
    ]),
    nearMatchDisplayName() {
      let displayName = null;
      if (this.fieldEnabled('LAST_NAME')) {
        displayName = this.nearMatch.pidSubmission.lastName;
      }
      if (displayName && (this.fieldEnabled('FIRST_NAME')
        || this.fieldEnabled('LAST_NAME'))) {
        displayName = `${displayName}, `;
      }
      if (this.fieldEnabled('FIRST_NAME')) {
        displayName = `${displayName + this.nearMatch.pidSubmission.firstName} `;
      }
      if (this.fieldEnabled('MIDDLE_NAME')
          && this.nearMatch.pidSubmission.middleName) {
        displayName = `${displayName + this.nearMatch.pidSubmission.middleName} `;
      }
      return (!displayName) ? '\u00A0' : displayName;
    },
    nameEnabled() {
      return (this.fieldEnabled('FIRST_NAME')
        || this.fieldEnabled('LAST_NAME')
          || this.fieldEnabled('MIDDLE_NAME'));
    },
  },
  methods: {
    ...mapActions('lookups', [
      'loadPersonTypes',
    ]),
    fieldEnabled(code) {
      return this.getFieldEnabledForPersonType(code, 'ASSIGN', this.nearMatch.pidSubmission.personType);
    },
  },
};
</script>

<style lang="sass" scoped>
  .near-match--row
    padding: 0.5rem 1rem
    border-bottom: 1px solid #eee
</style>
